import type { PageLoad } from './$types';
import * as m from '$lib/paraglide/messages';
import { serializeSchema } from '$lib/jsonld';
import { buildSeoMeta } from '$lib/seo';

export const prerender = true;

export const load: PageLoad = ({ url }) => {
	return {
		seo: buildSeoMeta({
			type: 'home',
			title: m.privacy_policy_of_me(),
			url: url.href,
			description: m.privacy_policy_page_description()
		}),
		jsonld: serializeSchema({
			'@context': 'https://schema.org',
			'@type': 'WebPage',
			name: m.privacy_policy_of_me(),
			description: m.privacy_policy_page_description(),
			publisher: {
				'@type': 'Person',
				name: 'Juslin Komenan'
			}
		})
	};
};
